module.exports = __webpack_public_path__ + "media/images/title_bg_transparent-52ad02d287c83a83f157215e303fddf1.png";